import AnnouncementBar, {
  AnnouncementBarProps,
} from '@algbra/ui/components/AnnouncementBar/AnnouncementBar'
import { ThemeContext } from '@algbra/ui/enums/theme'
import classNames from 'classnames'
import React, { ReactNode, useState } from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import styles from './PageLayout.module.scss'
import { ReactComponent as AlgbraLabsLogo } from '../../images/home/algbra-labs-logo.svg'

export type PageLayoutProps = {
  children: ReactNode
  theme?:
    | 'light'
    | 'dark'
    | 'darkTranslucent'
    | 'chaimama'
    | 'carbonTracking'
    | 'roadShow'
  announcement?: AnnouncementBarProps
  simpleHeader?: boolean
}

const PageLayout = React.forwardRef<HTMLDivElement, PageLayoutProps>(
  (props, ref) => {
    const { theme = 'light', children, announcement, simpleHeader } = props
    const [themeName, setThemeName] = useState<string>(theme)
    const setTheme = value => {
      setThemeName(value)
      return value
    }
    return (
      <ThemeContext.Provider value={{ theme: themeName, setTheme }}>
        <div id="portal"></div>
        <div
          ref={ref}
          className={classNames(styles.pageLayout, styles[`theme__${theme}`])}
        >
          <AnnouncementBar
            title="Algbra Labs bolsters diaspora-focused digital banking leadership with Isbank and RUUT strategic partnership"
            to="/news/algbra-labs-and-moka-united-the-fintech-subsidiary-of-isbank-announce-strategic-partnership-to-launch-ruut-in-the-uk/"
            target="_self"
            category="Press Release"
          />
          <Header
            hasBorder={true}
            simple={simpleHeader}
            hasAnnouncement={true}
          />
          <div className={styles.pageLayoutContent}>{children}</div>
          <Footer />
        </div>
      </ThemeContext.Provider>
    )
  }
)

export default PageLayout
